module.exports = __webpack_public_path__ + "static/media/applause.ce5ba3d9.png";